import { publications, otherPublications } from '../common/config/constants'
import Catalog from '../components/Catalog/Catalog'
import Footer from '../components/Footer/Footer'
import Navbar from '../components/Navbar/Navbar'

const Publications = () => {
    return (
        <>
            <Navbar />
            <div className="container-sm">
                {/* mapping publications , for sections with images */}
                <div className="row justify-content-center mt-5 vstack gap-3">
                    {
                        publications.details.map((item, index) => (
                            <Catalog index={index} item={item} key={index} />
                        ))
                    }
                </div>
                {/* section for other publications with text only no images , all data imported from constants */}
                <div className='mt-1 py-1'>
                    <h1>Other Publications</h1>
                </div>
                <table class="table mt-1 table-striped">
                    <thead>
                        <tr>
                            <th scope="col">No.</th>
                            <th scope="col">Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* iterating through the array in original order */}
                        {otherPublications.map((item, index) => {
                            const srNumber = otherPublications.length - index; // Calculate the descending serial number
                            const publicationDetails = Object.values(item)[0]; // Extract the publication details
                            return (
                                <tr key={srNumber}>
                                    <th scope='row'>{srNumber}</th>
                                    <td>{publicationDetails}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <Footer />
        </>
    )
}
export default Publications;